import { ChangeEvent, ElementRef, FC, useEffect, useRef, useState } from 'react';
import { AddressSuggestions, DaDataSuggestion, DaDataAddress } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';
import './react-address-dadata.scss';
import { formatOrderAddress } from 'utils/strActions';

interface AddressDadata3Props {
  onChange: (addressData: {
    apartment?: string;
    city?: string;
    street?: string;
    home?: string;
  }) => void;
  initialValues: {
    is_remote?: boolean;
    city?: string;
    street?: string;
    home?: string;
    apartment?: string;
  };
  disabled?: boolean;
}

export const AddressDadata3: FC<AddressDadata3Props> = ({
  onChange,
  initialValues,
  disabled,
}) => {
  const defaultQuery = formatOrderAddress(initialValues);

  const [value, setValue] = useState<DaDataSuggestion<DaDataAddress> | null>(null);
  const [defaultValue, setDefaultValue] = useState<string | undefined>(undefined);
  const suggestionsRef = useRef<ElementRef<typeof AddressSuggestions>>(null);

  const handleChange = (suggestion?: DaDataSuggestion<DaDataAddress>) => {
    setValue(suggestion ?? null);
  };

  useEffect(() => {
    const suggestionData = value?.data;

    if (suggestionData) {
      const addressData: {
        apartment: string;
        city: string;
        street: string;
        home: string;
      } = {
        apartment: '',
        city: '',
        street: '',
        home: '',
      };

      if (suggestionData.flat !== null) {
        addressData.apartment = suggestionData.flat;
      } else {
        addressData.apartment = '';
      }

      if (suggestionData.city !== null) {
        addressData.city = suggestionData.city;
      } else {
        addressData.city = '';
      }

      if (suggestionData.street_with_type !== null) {
        addressData.street = suggestionData.street_with_type;
      } else {
        addressData.street = '';
      }

      if (suggestionData.house !== null) {
        addressData.home = suggestionData.house;
      } else {
        addressData.home = '';
      }

      onChange(addressData);
    }

    if (defaultValue === '' && suggestionsRef.current) {
      suggestionsRef.current.setInputValue('');
      setValue(null);
      onChange({
        apartment: '',
        city: '',
        street: '',
        home: '',
      });
    }
  }, [value, defaultValue, onChange]);

  return (
    <div style={{ position: 'relative' }}>
      <AddressSuggestions
        ref={suggestionsRef}
        token={`${process.env.REACT_APP_API_KEY}`}
        value={value ?? undefined}
        onChange={handleChange}
        defaultQuery={defaultQuery}
        selectOnBlur={true}
        count={5}
        highlightClassName='suggestion_highlight'
        currentSuggestionClassName='suggestion_select'
        inputProps={{
          disabled,
          placeholder: 'Укажи адрес',
          onChange: (e: ChangeEvent<HTMLInputElement>) => {
            if (e) setDefaultValue(e.target.value.trimStart());
          },
        }}
      />
    </div>
  );
};
